import { render, staticRenderFns } from "./JdsScoreBadge.vue?vue&type=template&id=0fee08db&scoped=true&"
import script from "./JdsScoreBadge.vue?vue&type=script&lang=ts&"
export * from "./JdsScoreBadge.vue?vue&type=script&lang=ts&"
import style0 from "./JdsScoreBadge.vue?vue&type=style&index=0&id=0fee08db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fee08db",
  null
  
)

export default component.exports